<template lang="pug">
main.page-component(v-bind="$props"): slot
</template>

<script>
import Vue from "vue";

class Page extends Vue {
	mounted() {
		// console.debug("Page Props:", this.$props);
	}
}

export default Page;
</script>

<style lang="stylus" scoped>
.page-component
	p:first-of-type
		margin-top 0
</style>
